import { ReactNode } from "react"

interface Props {
  title: ReactNode
  children: ReactNode
}
export const FormRow = ({ title, children }: Props) => {
  return (
    <div className="form-row">
      <div className="form-row__title">{title}</div>
      <div className="form-row__content">
        <div className="form-row__content-inner">{children}</div>
      </div>
    </div>
  )
}
